import { SET_NAVIGATION, SET_NAVIGATION_SERVICES } from './types';
export default {
  [SET_NAVIGATION](state, payload) {
    state.navigation = payload;
  },
  [SET_NAVIGATION_SERVICES](state, payload) {
    state.navigationServices = payload;
  }
};